import { ISizeRecord } from "interfaces/ISize"
import { useNavigate } from "react-router-dom";

/**
 * custom props for the sizes table content
 */
interface Props {
    /**
     * The sizes object infromation
     */
    sizes: ISizeRecord[];
}

/**
 * The sizes table content
 */
export const TableContent = ({ sizes }: Props) => {
    const navigate = useNavigate();
    /**
     * handles the back button click and returns to the previous route
    */
    const onRowClick = (size: ISizeRecord) => navigate("/inventories/sizes/details", { state: size });
    return (
        <tbody>
            {sizes.map((size) => (
                <tr key={`size row ${size.id}`} onClick={() => onRowClick(size)} style={{ cursor: "pointer" }} >
                    <td className="text-center" >
                        {size.name}
                    </td>
                    <td className="text-center" >
                        {size.label}
                    </td>
                    <td className="text-center" >
                        <span
                            className={`status-badge ${size?.status ? "active" : "inactive"}`}
                        >
                            {size?.status ? "Activo" : "Inactivo"}
                        </span>
                    </td>
                </tr>
            ))
            }
        </tbody>
    )
}
